import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ChildThemetext'
})

export class ChildThemetext implements PipeTransform {

    transform(Line1: any, Line2: any): any {
        var tempArray = Line1.split("");
        //console.log(tempArray);
        var className = 'head-text-bg-';
        var html = '';
        var count = 1;
        tempArray.forEach( data => {
            html += '<span class="head-text-bg-1 '+className+count+'">'+data+'</span>';
            if(count == 7) count = 0;
            count++;
        });
        html += "<span>"+Line2+"</span>";
        return html;
    }
}